import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import EditAttachment from 'view/page/dataset-management/component/attachments/edit-attachment'
import formatArticle from 'helper/format-input-fields'
import PropTypes from 'prop-types'
import styles from 'view/component/table-columns/dataset-actions/styles'
import DeleteAttachment from './component/delete'
import DownloadAttachment from './component/download'

const Action = ({ attachment }) => {
  return (
    <span>
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item>
              <EditAttachment
                articleUuid={attachment.article_uuid}
                attachment={formatArticle(attachment)}
              />
            </Menu.Item>
            <Menu.Item>
              <DownloadAttachment attachment={attachment} />
            </Menu.Item>
            <Menu.Item>
              <DeleteAttachment attachment={attachment} />
            </Menu.Item>
          </Menu>
        }
        overlayStyle={{ zIndex: 1000 }}
        trigger={[DROPDOWN.TRIGGER]}
      >
        <div className={styles.show_more}>
          <span>More</span>
          <DownOutlined />
        </div>
      </Dropdown>
    </span>)
}

Action.propTypes = {
  attachment: PropTypes.object
}

export default Action
